import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { from } from 'rxjs';
import { FieldNumberComponent } from '../../../field-number.component';
import * as settings from './../../../../../common/settings';
import * as units from './../../../../../common/units';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-long-distance-field-r',
  templateUrl: './long-distance-field-r.component.html',
  styleUrls: ['./../../../Field-Styles.scss'],
})
export class LongDistanceFieldRComponent extends FieldNumberComponent implements OnInit {
  @Input() callBackChangeUnits: (args: any) => void;

  @Input() public units: settings.DisplayUnits = settings.DisplayUnits.Metric;
  unitsText: string = "";

  constructor(private translateService: TranslateService) {
    super();
    this.units = settings.userSettings.displayUnits;
    this.fixUnitsText();

    settings.userSettings.displayUnitsSub.subscribe(x => {
      this.changeUnits(x);
    });

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.fixUnitsText();
    });
  }

  ngOnInit() {
  }

  public changeUnitsClick() {
    this.changeUnits();
    if (this.callBackChangeUnits != undefined)
      this.callBackChangeUnits(this.units);
  }

  public changeUnits(units?: settings.DisplayUnits) {
    if (units != undefined)
      this.units = units;
    else
      this.units = settings.nextDisplayUnit(this.units);
    this.fixUnitsText();
  }

  public fixUnitsText() {
    switch (this.units) {
      case settings.DisplayUnits.Imperial:
        this.unitsText = this.translateService.instant("UNITS.FT");
        break;

      case settings.DisplayUnits.Metric:
        this.unitsText = this.translateService.instant("UNITS.KM");
        break;

      default:
        break;
    }
  }

  transVal(val: number): number {
    return val * 10 * units.METER_TO_FEET;
  }
}
